import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import patient from "../../../../assets/img/patient.jpg";
import rightArrow from "../../../../assets/img/arrow-right.svg";
import { showToast, ToastContainer } from "../../../../util/toastHelper";
import { ADMIN_CMS_SOCIAL_MEDIA } from "../../../../action/apiPath";
import { errorMessageCreate } from "../../../../util/custom";
import { ADMINSOCIALMEDIAPAGE } from "../../../../util/path";
import Loading from "react-fullscreen-loading";
import { CallWithAuth } from "../../../../action/apiActions";

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminSocialMediaUpdate = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const [socialMedia, setSocialMedia] = useState({
        platform: "",
        url: "",
        is_active: false
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        fetchSocialMedia();
    }, [id]);

    const fetchSocialMedia = () => {
        setSocialMedia({
            platform: location.state?.socialMedia?.platform || '',
            url: location.state?.socialMedia?.url || '',
            is_active: location.state?.socialMedia?.is_active || false
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSocialMedia({ ...socialMedia, [name]: value });
    };


    const handleSubmit = async () => {
        if (!socialMedia.platform) {
            showToast("error", "Platform is required.");
            return;
        }

        if (!socialMedia.url) {
            showToast("error", "URL is required.");
            return;
        }

        try {
            setIsSubmit(true);

            const response = await CallWithAuth("PATCH", `${ADMIN_CMS_SOCIAL_MEDIA}/${id}`, socialMedia);
            const message = errorMessageCreate(response?.res?.data?.message);

            if (response?.res?.status === 200) {
                showToast("success", message);
                setTimeout(() => {
                    navigate(ADMINSOCIALMEDIAPAGE);
                }, 1000);
            } else {
                showToast("error", message);
            }
        } catch (err) {
            console.error(err);
            showToast("error", "Failed to update social media.");
        } finally {
            setIsSubmit(false);
        }
    };

    return (
        <>
            <div>
                {isLoading && (<Loading loading background="rgba(236, 240, 241, 0.7)" loaderColor="#3498db" />)}

                <section className="site_hero patient_management_banner">
                    <div className="site_container">
                        <div className="site_row">
                            <div className="txt_colm">
                                <div className="txt_block">
                                    <h1>Update Social Media</h1>
                                    <p>Edit and update existing social media information</p>
                                </div>
                            </div>
                            <div className="img_colm">
                                <div className="img_block">
                                    <img src={patient} alt="Patient" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="mycustomclass patient_form_block">
                    <div className="site_container">
                        <div className="patient_form">
                            <div className="field_block">
                                <label htmlFor="question">Platform <span className="text-danger">*</span></label>
                                <select
                                    name="platform"
                                    value={socialMedia.platform}
                                    onChange={handleInputChange}
                                    disabled
                                >
                                    <option value="">Select Platform</option>
                                    <option value="youtube">Youtube</option>
                                    {/* <option value="twitter">Twitter</option> */}
                                    <option value="linkedin">Linkedin</option>
                                    <option value="facebook">Facebook</option>
                                    <option value="instagram">Instagram</option>
                                    {/* <option value="tiktok">Tiktok</option> */}
                                </select>
                            </div>

                            <div className="field_block">
                                <label htmlFor="answer">URL <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    name="url"
                                    className="text_field"
                                    placeholder="Enter URL"
                                    value={socialMedia.url}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="field_block">
                                <label htmlFor="is_active">Active?</label>
                                <input
                                    type="checkbox"
                                    name="is_active"
                                    checked={socialMedia.is_active}
                                    onChange={(e) => {
                                        setSocialMedia({
                                            ...socialMedia,
                                            ...{ is_active: e.target.checked }
                                        })
                                    }}
                                />
                            </div>
                            
                            <div className="field_block">
                                <div className="btn_row">
                                    <button disabled={isLoading || isSubmit} onClick={handleSubmit}>
                                        <span>Update</span> <img src={rightArrow} alt="Arrow" />
                                        {isSubmit && (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <ToastContainer />
            </div>
        </>
    );
};
export default AdminSocialMediaUpdate;
